import { Component, Inject } from '@angular/core';
import { ISpecial } from '../../../interfaces/special';
import { IRestaurantInfo} from '../../../interfaces/restaurant';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SpecialsStoreService } from '../../../services/specials/specials-store.service';
import { distinctUntilChanged } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

type SpecialDateValue = Date | string | null;

type SpecialRangeForm = {
  start: FormControl<SpecialDateValue>;
  end: FormControl<SpecialDateValue>;
};

type SpecialForm = {
  range: FormGroup<SpecialRangeForm>;
  name: FormControl<string>;
  specialFile: FormControl<File | null>;
  restaurants: FormControl<number[] | null>;
  toAll: FormControl<boolean>;
};

@UntilDestroy()
@Component({
  selector: 'app-edit-special',
  templateUrl: './edit-special.component.html',
  styleUrls: ['./edit-special.component.scss']
})
export class EditSpecialComponent {

  public isLoading = false;
  public isChang = false;

  form = new FormGroup<SpecialForm>({
    range: new FormGroup<SpecialRangeForm>({
      start: new FormControl<SpecialDateValue>(this.data.special.scheduleStart, Validators.required),
      end: new FormControl<SpecialDateValue>(this.data.special.scheduleEnd, Validators.required),
    }),
    name: new FormControl(this.data.special.name, { nonNullable: true, validators: [Validators.required, Validators.minLength(3)] }),
    specialFile: new FormControl<File | null>(null),
    restaurants: new FormControl<number[] | null>(this.data.special.attachedToAll
      ? {value: null, disabled: true}
      : this.data.special.attachedRestaurantIds
    ),
    toAll: new FormControl(this.data.special.attachedToAll, { nonNullable: true }),
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      chainId: number,
      allRestaurants: IRestaurantInfo[],
      special: ISpecial
    },
    private specialsStore: SpecialsStoreService,
  ) {
    this.form.controls.toAll.valueChanges.pipe(
      distinctUntilChanged(),
      untilDestroyed(this)
    ).subscribe((value: boolean) => {
      if (value) {
        this.form.controls.restaurants.reset({
          value: [],
          disabled: true,
        });
      } else {
        this.form.controls.restaurants.reset({
          value: null,
          disabled: false,
        });
      }
    });
    this.form.controls.range.controls.start.valueChanges.pipe(
      distinctUntilChanged(),
      untilDestroyed(this)
    ).subscribe(_ => {
      this.isChang = true;
    });
  }

  onSubmit(): void {
    this.isLoading = true;
    const formValue = this.form.getRawValue();

    if (!formValue.range.start || !formValue.range.end) {
      this.isLoading = false;
      return;
    }

    const startDateTime = new Date(formValue.range.start).toISOString();
    const endDateTime = this.specialsStore.adjustEndDate(formValue.range.end);

    this.specialsStore.updateSpecial(
      this.data.special.id,
      this.data.chainId,
      formValue.name,
      startDateTime,
      endDateTime,
      formValue.specialFile,
      formValue.toAll ? [] : formValue.restaurants
    ).pipe(
      untilDestroyed(this)
    ).subscribe(
      () => (this.isLoading = false),
      () => (this.isLoading = false)
    );
  }

  public myFilterStart(inD: Date | null): boolean {
    const startDateTime = new Date(new Date().setHours(0, 0, 0, 0));

    if (!inD) {
      return true;
    }
    return inD >= startDateTime;
  }

  public myFilterEmpty(): boolean {
    return true;
  }
}
